function starfireTrapFocus(container, elementToFocus) {
  if (window.theme && theme.a11y && theme.a11y.trapFocus) {
    theme.a11y.trapFocus({
      container: container,
      elementToFocus: elementToFocus || container,
      namespace: 'bis-modal'
    });
    return;
  }
  (elementToFocus || container).focus();
}

function starfireRemoveTrapFocus(elementToFocus) {
  if (window.theme && theme.a11y && theme.a11y.removeTrapFocus) {
    theme.a11y.removeTrapFocus({
      container: document.querySelector('bis-modal'),
      namespace: 'bis-modal'
    });
  }
  if (elementToFocus) elementToFocus.focus();
}

function parseBisJson(value, fallback) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
}

if (!customElements.get('bis-modal')) {
  customElements.define(
    'bis-modal',
    class BISModal extends HTMLElement {
      constructor() {
        super();

        const dataEl = document.querySelector('[data-bis-display-data]');
        this.allVariantsJson = parseBisJson(dataEl && dataEl.textContent, []);
        this.klaviyoApiVersion = this.dataset.apiVersion;
        this.preorderTemplate = this.dataset.preorderTemplate === 'true';
        this.defaultHeaders = {
          revision: this.klaviyoApiVersion,
          accept: 'application/json',
          'content-type': 'application/json'
        };

        this.closeEls = this.querySelectorAll('.bis-modal__close');
        this.alertEls = this.querySelectorAll('.bis-alert');
        this.successEl = this.querySelector('.bis-alert.success');
        this.errorEl = this.querySelector('.bis-alert.error');
        this.errorMap = JSON.parse(this.errorEl.dataset.errorMap);

        this.closeEls.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
          });
        });

        this.addEventListener('keyup', (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', (e) => {
          if (e.target === this) this.hide();
        });

        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        this.querySelector('.bis-modal__form-container').append(this.querySelector('template').content.cloneNode(true));

        this.selectEl = this.querySelector('select');
        if (this.selectEl) this.selectEl.addEventListener('change', this.onSelectChange.bind(this));
        this.formEl = this.querySelector('form');
        this.formEl.addEventListener('submit', this.handleSubmit.bind(this));
        this.submitBtnEl = this.formEl.querySelector('[type="submit"]');
        this.phoneInputEl = this.querySelector('[name="phone"]');
        this.alertType = this.querySelector('[name="alert_type"]:checked').value;
        this.alertTypeInputEls = this.querySelectorAll('[name="alert_type"]');

        this.alertTypeInputEls.forEach((el) => el.addEventListener('change', this.onAlertTypeChange.bind(this)));

        this.iti = window.intlTelInput(this.phoneInputEl, {
          initialCountry: 'auto',
          geoIpLookup: (success, failure) => {
            fetch('/browsing_context_suggestions.json')
              .then((res) => res.json())
              .then((data) => success(data.detected_values?.country?.handle.toLowerCase()) || 'us')
              .catch(() => failure());
          },
          dropdownContainer: document.body
        });
      }

      async handleSubmit(e) {
        e.preventDefault();

        this.submitBtnEl.disabled = true;
        this.resetAlerts();

        if (this.alertType === 'Text' && !this.validatePhone()) return;

        const formData = new FormData(this.formEl);
        const formApiKey = formData.get('api_key');
        const formId = formData.get('id');
        const formEmail = formData.get('email');
        const formSub = formData.get('subscribe');
        const formPhone = this.alertType === 'Text' && this.iti ? this.iti.getNumber() : false;
        const formListId = formPhone ? formData.get('list_id_sms') : formData.get('list_id_email');

        try {
          const data = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: formPhone ? ['SMS'] : ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: formPhone ? null : formEmail,
                      phone_number: formPhone || null
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${formId}`
                  }
                }
              }
            }
          };
          const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${formApiKey}`, {
            method: 'POST',
            headers: this.defaultHeaders,
            body: JSON.stringify(data)
          });

          if (response.ok) {
            if (formSub) {
              try {
                const subData = {
                  data: {
                    type: 'subscription',
                    attributes: {
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: formPhone ? null : formEmail,
                            phone_number: formPhone || null
                          }
                        }
                      }
                    },
                    relationships: { list: { data: { type: 'list', id: `${formListId}` } } }
                  }
                };

                await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${formApiKey}`, {
                  method: 'POST',
                  headers: this.defaultHeaders,
                  body: JSON.stringify(subData)
                });
              } catch (error) {
                console.error(error);
              }
            }
            this.showAlert(this.successEl);
          } else {
            const errorJson = await response.json();
            const errorText = errorJson.errors[0]?.detail;
            if (errorJson && errorText) {
              this.errorEl.textContent = errorText;
            }
            this.showAlert(this.errorEl);
            console.error(errorText);
          }
        } catch (error) {
          this.showAlert(this.errorEl);
          console.error(error);
        } finally {
          this.submitBtnEl.disabled = false;
        }
      }

      validatePhone() {
        if (!this.iti || this.alertType !== 'Text') return;

        if (this.phoneInputEl.value.trim()) {
          if (this.iti.isValidNumber()) {
            this.phoneInputEl.classList.remove('error');
            this.resetAlerts();
            return true;
          }

          const errorCode = Math.max(this.iti.getValidationError(), 0);
          const errorMsg = this.errorMap[errorCode] || this.errorEl.dataset.original;

          this.phoneInputEl.classList.add('error');
          this.errorEl.textContent = errorMsg;
          this.showAlert(this.errorEl);
          this.submitBtnEl.disabled = false;
          return false;
        }

        this.submitBtnEl.disabled = false;
        return false;
      }

      show(opener) {
        this.openedBy = opener;
        document.body.classList.add('bis-modal--open');
        this.setAttribute('open', '');
        document.body.dispatchEvent(new CustomEvent('bisModalOpened'));
        starfireTrapFocus(this, this.querySelector('[role="dialog"]'));
      }

      hide() {
        document.body.classList.remove('bis-modal--open');
        document.body.dispatchEvent(new CustomEvent('bisModalClosed'));
        this.removeAttribute('open');
        starfireRemoveTrapFocus(this.openedBy);
        this.resetAlerts();
      }

      findVariant(variant) {
        if (!variant) return null;
        const id = Number(variant.id);
        return this.allVariantsJson.find((el) => Number(el.id) === id) || null;
      }

      onVariantChange(e) {
        const variant = e.detail && e.detail.variant;
        if (!this.selectEl || !variant) return;
        const fullVariant = this.findVariant(variant);
        if (!fullVariant) return;

        const qty = parseInt(fullVariant.inventory_quantity, 10) || 0;
        if (qty <= 0 || this.preorderTemplate) {
          const option = this.selectEl.querySelector('option[value="' + fullVariant.id + '"]');
          if (option) this.selectEl.value = String(fullVariant.id);
        }
      }

      onSelectChange() {
        this.submitBtnEl.disabled = false;
        this.resetAlerts();
      }

      onAlertTypeChange() {
        const activeType = this.querySelector('[name="alert_type"]:checked').value;
        this.alertType = activeType;
        this.querySelectorAll('input[data-alert-type]').forEach((el) => {
          el.disabled = el.dataset.alertType !== activeType;
          el.required = el.dataset.alertType === activeType;
        });
        this.resetAlerts();
      }

      resetAlerts() {
        this.alertEls.forEach((el) => {
          this.hideAlert(el);
        });
        this.errorEl.textContent = this.errorEl.dataset.original;
      }

      showAlert(el) {
        if (!el) return;

        let newFocusableElement = false;
        el.setAttribute('aria-hidden', false);
        el.querySelectorAll('[focusable="false"]').forEach((focusEl) => {
          focusEl.setAttribute('focusable', true);
          focusEl.disabled = false;
          newFocusableElement = true;
        });
        if (newFocusableElement) starfireTrapFocus(this, document.activeElement);
      }

      hideAlert(el) {
        if (!el) return;

        let focusableElementRemoved = false;
        el.setAttribute('aria-hidden', true);
        el.querySelectorAll('[focusable="true"]').forEach((focusEl) => {
          focusEl.setAttribute('focusable', false);
          focusEl.disabled = true;
          focusableElementRemoved = true;
        });
        if (focusableElementRemoved) starfireTrapFocus(this, this.querySelector('[role="dialog"]'));
      }
    }
  );
}

if (!customElements.get('bis-modal-opener')) {
  customElements.define(
    'bis-modal-opener',
    class BISModalOpener extends HTMLElement {
      constructor() {
        super();

        this.buttonEl = this.querySelector('button');
        this.modalEl = document.querySelector(this.dataset.modal);
        const dataEl = document.querySelector('[data-bis-display-data]');
        this.allVariantsJson = parseBisJson(dataEl && dataEl.textContent, []);
        this.hiddenIds = parseBisJson(this.dataset.hiddenVariantIds, []).map((variantId) => parseInt(variantId, 10));
        this.preorderTemplate = this.dataset.preorderTemplate === 'true';
        this.productId = this.dataset.productId;

        if (!this.buttonEl || !this.modalEl) return;
        this.buttonEl.addEventListener('click', () => {
          this.modalEl.show(this.buttonEl);
        });

        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }

      findVariant(variant) {
        if (!variant) return null;
        const id = Number(variant.id);
        return this.allVariantsJson.find((el) => Number(el.id) === id) || variant;
      }

      getQuantity(variant) {
        if (!variant) return 0;
        if (variant.inventory_quantity != null && variant.inventory_quantity !== '') {
          const parsed = parseInt(variant.inventory_quantity, 10);
          if (!Number.isNaN(parsed)) return parsed;
        }
        const fromWindow =
          window.inventories &&
          this.productId &&
          window.inventories[this.productId] &&
          window.inventories[this.productId][variant.id];
        if (fromWindow && fromWindow.quantity != null) {
          return parseInt(fromWindow.quantity, 10) || 0;
        }
        return 0;
      }

      onVariantChange(e) {
        const variant = e.detail && e.detail.variant;
        if (!variant) {
          this.classList.add('hide');
          return;
        }
        const fullVariant = this.findVariant(variant);
        this.classList.toggle('hide', this.shouldHide(fullVariant));
      }

      shouldHide(variant) {
        if (!variant) return true;
        if (this.hiddenIds.includes(Number(variant.id))) return true;
        if (variant.available === false) return false;
        if (this.preorderTemplate) return false;
        const qty = this.getQuantity(variant);
        const management = variant.inventory_management;
        const policy = variant.inventory_policy;
        // Untracked inventory is never "preorder" and never needs BIS when available.
        const isTracked = management === 'shopify';
        if (!isTracked) return variant.available !== false;
        const isPreorder = variant.available && qty <= 0 && policy === 'continue';
        if (isPreorder) return false;
        return qty > 0;
      }

      disconnectedCallback() {
        if (this.modalEl) this.modalEl.remove();
      }
    }
  );
}
